export const correctTextFromQueryParams = (text: string) => {
  return text.replace(/\s/g, "+"); // + - in parameters is not a space encoded, it is just a base64 symbol
};
